import React, { Key, ReactElement } from 'react'
import { DatePicker, DatePickerProps, PickersTextFieldProps } from '@mui/x-date-pickers'
import { getDateFormatForLocale } from 'src/service/utils/DateFormatUtils'
import { SupportedLocale } from 'src/service/view-model/base/localization/SupportedLocale'
import { PickersTextFieldDefault } from 'src/ui-shared/base/form/control/PickersTextField'

interface CustomProps {
  pickersTextField?: React.ElementType<PickersTextFieldProps>
  pickersTextFieldClassName?: string
  error?: boolean
  locale: SupportedLocale
}

type DatePickerPropsExtended = DatePickerProps & CustomProps

export const DatePickerDefault = (
  props: DatePickerPropsExtended & React.RefAttributes<HTMLDivElement>,
): ReactElement => {
  const { pickersTextField, pickersTextFieldClassName, locale, error, ...rest } = props

  return (
    <DatePicker
      key={rest.value as unknown as Key}
      format={getDateFormatForLocale(locale)}
      slots={{
        textField: pickersTextField ? pickersTextField : PickersTextFieldDefault,
      }}
      className={pickersTextFieldClassName}
      {...rest}
      slotProps={{
        ...rest.slotProps,
        textField: {
          ...rest.slotProps?.textField,
          error: error,
        },
      }}
    />
  )
}
